import { createUseStyles } from 'react-jss';
import { getDirectionDefaults, getGap } from './Spacer.helpers';
import { SpacerThemeProps, SpacerThemeRuleNames } from './Spacer.types';

export const useStyles = createUseStyles<SpacerThemeRuleNames, SpacerThemeProps>({
  wrapper: (props) => ({
    display: 'flex',
    gap: getGap(props?.gap),
    ...getDirectionDefaults(props?.direction),
    ...(props?.centered ? { alignItems: 'center', justifyContent: 'center' } : {}), // note: centered overrides the alignItems and justifyContent from getDirectionDefaults
    ...props?.style?.wrapper,
    ...props?.style,
  }),
});
